import * as React from 'react';
import {useRef} from 'react';
import {view, css} from '@sail/ui';
import {useMove} from '@react-aria/interactions';

export const ResizableContainer = view.div.create(
  ({minWidth = 60, width = 250, maxWidth = 500, ...props}, View) => {
    const ref = useRef(null);
    const sizeRef = useRef(width ?? null);
    const {moveProps} = useMove({
      onMoveStart(e) {
        if (sizeRef.current === null) {
          sizeRef.current = ref?.current?.offsetWidth ?? null;
        }
        document.body.style.cursor = 'col-resize';
      },
      onMove(e) {
        sizeRef.current = Math.min(
          Math.max((sizeRef?.current ?? 0) + e.deltaX * 1.5, minWidth),
          maxWidth,
        );

        if (ref && ref.current) {
          ref.current.style.width = `${sizeRef.current}px`;
        }
      },
      onMoveEnd() {
        document.body.style.cursor = '';
      },
    });
    return (
      <View
        ref={ref}
        uses={[props]}
        css={{
          position: css.value('relative'),
          width: css.value(width ? `${width}px` : 'auto'),
          background: 'surface',
          borderRadius: 'small',
          padding: 'xsmall',
          paddingRight: 'medium',
          border: css.value('1px solid $color.neutral150'),
        }}
      >
        <view.div css={{overflow: css.value('hidden'), padding: 'xxsmall'}}>
          {props.children}
        </view.div>
        <view.div
          uses={[moveProps]}
          css={{
            position: css.value('absolute'),
            inset: css.value('0 -4px 0 auto'),
            width: css.value('$space.medium'),
            cursor: css.value('col-resize'),
            '&:before, &:after': {
              content: css.value('""'),
              position: css.value('absolute'),
              inset: css.value('$space.small 0'),
              display: css.value('block'),
              width: css.value('2px'),
              background: css.value('$color.neutral150'),
              borderRadius: 'small',
            },
            '&:after': {
              transform: css.value('translate3d(4px, 0, 0)'),
            },
          }}
          aria-label="Resize handle"
        />
      </View>
    );
  },
);
